import store from '../store'
import { AUTH_LOGOUT } from '@/store/actions/auth'

export default {
  getNextPath(to) {
    let nextPath = null
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!store.getters.isAuthenticated) {
        nextPath = { name: 'Login' }
      } else if (store.getters.needsToRelog) {
        store.dispatch(AUTH_LOGOUT)
        nextPath = { name: 'Login' }
      } else {
        if (store.getters.isAdmin) { 
          if (to.matched.some(record => record.meta.requiresCustomer)) {
            if (!store.getters.hasCustomer) {
              nextPath = { name: 'ChooseCustomer' }
            }
          }
        }
      }
    }

    return nextPath
  }
}